import { render } from "./app-preview-picture.vue?vue&type=template&id=86b51a6e"
import script from "./app-preview-picture.vue?vue&type=script&lang=js"
export * from "./app-preview-picture.vue?vue&type=script&lang=js"

import "./app-preview-picture.vue?vue&type=style&index=0&id=86b51a6e&lang=scss"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__